
import Component from "vue-class-component";
import Vue from "vue";
import Modal from "@/components/Modal.vue";
import TermsModalContent from "@/components/TermsModalContent.vue";
import config from "@/utils/config";

@Component({
  components: {
    Modal,
    TermsModalContent
  },
})
export default class Footer extends Vue {
  termsModal = false;
  config = config;

  closeModal() {
    this.termsModal = false;
  }
}
